module.exports = __webpack_public_path__ + "static/media/DeleteIcon_Disabled_01.e7749e00.svg";